import React from 'react';
import { EnvironmentService } from "../../../services/EnvironmentService";
import { EskimosLoginFormTemplate } from '../template/eskimos/EskimosLoginFormTemplate';
import { KutubeeLoginFormTemplate } from '../template/kutubee/KutubeeLoginFormTemplate';
import { ToBuildAProfileLoginFormTemplate } from '../template/2bap/2bapLoginFormTemplate';
import PropTypes from 'prop-types';
import { withTranslate } from '../../../decorators/withTranslate';

const env = new EnvironmentService();

var ValidationRules = (t) => ({
  rules: {
    email: {
      required: true,
      maxlength: 100
    },
    password: {
      required: true,
      maxlength: 256
    },
  },
  messages: {
    email: {
      required: t('Please enter email address')
    },
    password: {
      required: t('Please enter password')
    },
  }
});

var defaultProps = {
  email: "",
  password: "",
};

/**
 * Login widget
 * @prop (function) onSignIn sign in callback
 */
var LoginWidget = React.createClass({
  
  item: defaultProps,

  propTypes: {
    isLoginLoading: PropTypes.bool
  },
  
  form: null,
  emailField: null,
  passwordField: null,

  componentDidMount: function () {
    $(this.form).validate(ValidationRules(this.props.t));
  },

  render: function () {
    const { t, isLoginLoading, errorMessage } = this.props;
    
    const FormTemplate = this.getFormTemplate();
    
    return (
      <FormTemplate
        t={t}
        onSubmit={this._onSignInHandler}
        formRef={(form) => { this.form = form; }}
        emailFieldRef={(field) => { this.emailField = field; }}
        passwordFieldRef={(field) => { this.passwordField = field; }}
        isLoading={isLoginLoading}
        errorMessage={errorMessage}
      />
    )
  },
  
  getFormTemplate() {
    if (env.isKutubee) {
      return KutubeeLoginFormTemplate;
    } else if (env.is2bap) {
      return ToBuildAProfileLoginFormTemplate;
    } else {
      return EskimosLoginFormTemplate;
    }
  },

  _onSignInHandler: function (event) {
    event.preventDefault();
    if (typeof this.props.onSignIn !== "function") return;
    
    if (!$(this.form).valid()) return;

    const data = this.item;
    data.email = this.emailField.value;
    data.password = this.passwordField.value;

    this.props.onSignIn(data);
  }
  
});

module.exports = withTranslate('main')(LoginWidget);
